import React from "react";
import { useContext } from "react";
import AppContext from "./AppContext";

export const NavBar = () => {
  const { data } = useContext(AppContext);

  return <img style={{ width: "9rem", position: "absolute",marginLeft: "18rem"}} src={data.logoURL} />;
};
